import React from 'react';

 export const AboutUs = () => {
  return (
    <div className="about-us-container">
      <h1>About Us</h1>
      <p>Welcome to QuizMaster, your ultimate destination for fun and challenging quizzes!</p>
      <p>Our mission is to provide an engaging platform where users can test their knowledge across various topics and improve their skills.</p>
      <p>Whether you are a trivia enthusiast or just looking to learn something new, QuizMaster has something for everyone.</p>
      <p>Join our community and start quizzing today!</p>
    </div>
  );
};

